export interface TransferLimits {
  maxFileCount: number;
  warnTotalBytes: number;
  hardMaxTotalBytes: number;
  warnEstimatedSeconds: number;
  maxChunkCount: number;
  maxMetadataBytes: number;
  maxFileNameLength: number;
  maxMimeTypeLength: number;
  maxExpandedBytes: number;
}

export const DEFAULT_TRANSFER_LIMITS: Readonly<TransferLimits> = Object.freeze({
  maxFileCount: 6,
  warnTotalBytes: 64 * 1024,
  hardMaxTotalBytes: 256 * 1024,
  warnEstimatedSeconds: 90,
  maxChunkCount: 1_200,
  maxMetadataBytes: 16 * 1024,
  maxFileNameLength: 120,
  maxMimeTypeLength: 120,
  maxExpandedBytes: 256 * 1024,
});

export function resolveTransferLimits(
  overrides: Partial<TransferLimits> = {},
): TransferLimits {
  const limits = { ...DEFAULT_TRANSFER_LIMITS, ...overrides };
  const positiveIntegerKeys = [
    "maxFileCount",
    "warnTotalBytes",
    "hardMaxTotalBytes",
    "warnEstimatedSeconds",
    "maxChunkCount",
    "maxMetadataBytes",
    "maxFileNameLength",
    "maxMimeTypeLength",
    "maxExpandedBytes",
  ] as const;

  for (const key of positiveIntegerKeys) {
    if (!Number.isSafeInteger(limits[key]) || limits[key] <= 0) {
      throw new Error(`${key} must be a positive safe integer.`);
    }
  }

  if (limits.warnTotalBytes > limits.hardMaxTotalBytes) {
    throw new Error("warnTotalBytes cannot exceed hardMaxTotalBytes.");
  }
  if (limits.maxExpandedBytes < limits.hardMaxTotalBytes) {
    throw new Error("maxExpandedBytes cannot be lower than hardMaxTotalBytes.");
  }

  return limits;
}
